// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__G1K8Z","content":"styles_content__1vyx_","checkbox":"styles_checkbox__1tcyf","checkboxLabel":"styles_checkboxLabel__3Ozys"};